<script setup lang="ts">
const router = useRouter()
const authStore = useAuthStore()
const nutzerStore = useNutzerStore()

const nutzer = computed(() => nutzerStore.getNutzerById((authStore.currentUser as any)?.id))
const hasCredentials = computed(() => !!(nutzer.value as any)?.hasHortProCredentials)

onMounted(() => {
    if (authStore.currentUser) {
        nutzerStore.fetchNutzerById((authStore.currentUser as any).id)
    }
})

function goToSettings() {
    router.push({ name: 'settings', hash: '#hortpro' })
}

const statusColor = computed(() => {
    return hasCredentials.value ? 'success' : 'grey'
})

const statusText = computed(() => {
    return hasCredentials.value ? 'Verbunden' : 'Nicht verbunden'
})

const statusIcon = computed(() => {
    return hasCredentials.value ? 'mdi-check-circle' : 'mdi-link-variant-off'
})
</script>

<template>
    <v-card hover @click="goToSettings" class="cursor-pointer">
        <v-card-text>
            <div class="d-flex align-center mb-3">
                <v-avatar :color="statusColor" size="48" class="mr-3">
                    <v-icon :icon="statusIcon" size="24" color="white"></v-icon>
                </v-avatar>
                <div class="flex-grow-1">
                    <div class="text-caption text-medium-emphasis">HortPro-Verbindung</div>
                    <div class="text-h6 font-weight-medium">{{ statusText }}</div>
                </div>
            </div>

            <v-divider class="mb-3"></v-divider>

            <div class="d-flex justify-space-between align-center">
                <div class="text-body-2 text-medium-emphasis">
                    {{ hasCredentials ? 'Zugangsdaten verwalten' : 'Account verknüpfen' }}
                </div>
                <v-icon>mdi-chevron-right</v-icon>
            </div>
        </v-card-text>
    </v-card>
</template>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    transition: transform 0.2s ease;
}

.cursor-pointer:hover {
    transform: translateY(-2px);
}
</style>